/* eslint no-unused-vars:0 */
import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import 'bootstrap';
import pageContext from '@bingads-webui-static-legacy/page-context';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';
import ToggleView from '@bingads-webui-component-legacy/toggle/view/index';
import DeviceTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/deviceTargets';
import OriginalDeviceTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/originalDeviceTargets';
import AgeTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/ageTargets';
import GenderTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/genderTargets';
import NativeAdViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/nativeAds';
import MultimediaAdViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/multimediaAds';
import tmpl from '@bingads-webui-campaign-legacy/base-targets/template/baseTargets.pug';
import originalDeviceTargetTmpl from '@bingads-webui-campaign-legacy/base-targets/template/originalDeviceTargets.pug';
import config from '@bingads-webui-component-legacy/config/index';
import targetTypes from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetTypes';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const targetTypeToViewModel = {
  Device: DeviceTargetViewModel,
  OriginalDevice: OriginalDeviceTargetViewModel,
  Age: AgeTargetViewModel,
  Gender: GenderTargetViewModel,
  NativeAd: NativeAdViewModel,
  MultimediaAd: MultimediaAdViewModel,
};

const targetTypeToTmpl = {
  Device: tmpl,
  OriginalDevice: originalDeviceTargetTmpl,
  Age: tmpl,
  Gender: tmpl,
  NativeAd: tmpl,
  MultimediaAd: tmpl,
};

function TargetViewModelFactory(targetType, options) {
  return new targetTypeToViewModel[targetType](options);
}

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    _.defaults(this.options, {
      campaignId: '',
      adgroupId: '',
      level: 'campaign',
      scenario: 'creation-workflow',
      targetType: targetTypes.Device,
      DeviceTypeTabletsCampaignBidAdjustment: 0,
      DeviceTypeTabletsAndroidCampaignBidAdjustment: 0,
      DeviceTypeTabletsBlackBerryCampaignBidAdjustment: 0,
      DeviceTypeTabletsiOSCampaignBidAdjustment: 0,
      DeviceTypeTabletsWindowsCampaignBidAdjustment: 0,
      DeviceTypeTabletsOtherCampaignBidAdjustment: 0,
      DeviceTypeSmartphonesAndroidCampaignBidAdjustment: 0,
      DeviceTypeSmartphonesBlackBerryCampaignBidAdjustment: 0,
      DeviceTypeSmartphonesiOSCampaignBidAdjustment: 0,
      DeviceTypeSmartphonesCampaignBidAdjustment: 0,
      DeviceTypeSmartphonesWindowsCampaignBidAdjustment: 0,
      DeviceTypeSmartphonesOtherCampaignBidAdjustment: 0,
      DeviceTypeComputersCampaignBidAdjustment: 0,
      DeviceTypeComputersWindowsCampaignBidAdjustment: 0,
      AgeTypeEighteenToTwentyFiveCampaignBidAdjustment: 0,
      AgeTypeTwentyFiveToThirtyFiveCampaignBidAdjustment: 0,
      AgeTypeThirtyFiveToFiftyCampaignBidAdjustment: 0,
      AgeTypeFiftyToSixtyFiveCampaignBidAdjustment: 0,
      AgeTypeSixtyFiveAndAboveCampaignBidAdjustment: 0,
      GenderTypeMaleCampaignBidAdjustment: 0,
      GenderTypeFemaleCampaignBidAdjustment: 0,
      DeviceTypeTabletsAdgroupBidAdjustment: 0,
      DeviceTypeTabletsAndroidAdgroupBidAdjustment: 0,
      DeviceTypeTabletsBlackBerryAdgroupBidAdjustment: 0,
      DeviceTypeTabletsiOSAdgroupBidAdjustment: 0,
      DeviceTypeTabletsWindowsAdgroupBidAdjustment: 0,
      DeviceTypeTabletsOtherAdgroupBidAdjustment: 0,
      DeviceTypeSmartphonesAdgroupBidAdjustment: 0,
      DeviceTypeSmartphonesAndroidAdgroupBidAdjustment: 0,
      DeviceTypeSmartphonesBlackBerryAdgroupBidAdjustment: 0,
      DeviceTypeSmartphonesiOSAdgroupBidAdjustment: 0,
      DeviceTypeSmartphonesWindowsAdgroupBidAdjustment: 0,
      DeviceTypeSmartphonesOtherAdgroupBidAdjustment: 0,
      DeviceTypeComputersAdgroupBidAdjustment: 0,
      DeviceTypeComputersWindowsAdgroupBidAdjustment: 0,
      AgeTypeEighteenToTwentyFiveAdgroupBidAdjustment: 0,
      AgeTypeTwentyFiveToThirtyFiveAdgroupBidAdjustment: 0,
      AgeTypeThirtyFiveToFiftyAdgroupBidAdjustment: 0,
      AgeTypeFiftyToSixtyFiveAdgroupBidAdjustment: 0,
      AgeTypeSixtyFiveAndAboveAdgroupBidAdjustment: 0,
      GenderTypeMaleAdgroupBidAdjustment: 0,
      GenderTypeFemaleAdgroupBidAdjustment: 0,
      NativeAdTypeNativeAdsBidsCampaignBidAdjustment: 0,
      NativeAdTypeNativeAdsBidsAdgroupBidAdjustment: 0,
      MultimediaAdTypeMultimediaAdsBidsCampaignBidAdjustment: targetConstants.multimediaAdDefaultBid,
      MultimediaAdTypeMultimediaAdsBidsAdgroupBidAdjustment: targetConstants.multimediaAdDefaultBid,
      fromSettingsGrid: false,
      showLevelToggle: true,
      isNativeAdsRebrandingEnabled: pageContext.Permissions.IsNativeAdsRebrandingEnabled,
      currentCampaign: pageContext.CurrentCampaign,
      currentAdGroup: pageContext.CurrentAdGroup,
    });

    if (pageContext.Permissions.IsPersonalizedOffersEnabled) {
      this.populateCashbackProperties(this.options);
    }

    this.isMSANBoostEnabled = pageContext.Permissions.IsAmplifyEnabled;
    this.isHideBidAdjustmentForBoostEnabled = pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.HideBidAdjustmentForBoost;

    this.viewmodel = new TargetViewModelFactory(this.options.targetType, options);

    this.toggleView = new ToggleView({
      toggleText: {
        // #TOGGLEBUG These keys were missing in the old system
        // In the new i18n system, On/Off text unexpectedly appears in the UI
        on: undefined, // i18n.getString('Toggle_On'),
        off: undefined,  // i18n.getString('Toggle_Off'),
      },
      labelledbyId: 'base-use-campaign-settings',
    });
    this.toggleView.setToggleState(this.viewmodel.useCampaignSettings() ? 'on' : 'off');
    this.listenTo(this.toggleView, 'change', (toggleState) => {
      this.viewmodel.useCampaignSettings(toggleState === 'on');
    }, this);
  }

  populateCashbackProperties(options) {
    Object.keys(options).forEach((key) => {
      if (key.search('DeviceType') !== -1 || key.search('NativeAdType') !== -1) {
        const cashbackKey = key.replace(/BidAdjustment$/, 'CashbackPercent');
        const originalValue = options[cashbackKey];

        options[cashbackKey] = originalValue == null ? '' : options[cashbackKey];
      }
    });
  }

  render() {
    this.$el.html(targetTypeToTmpl[this.options.targetType]({
      i18n,
      level: this.options.level,
      targetDescription: this.viewmodel.targetDescription,
      targetHeader: this.viewmodel.targetHeader,
      bidAdjustmentHeader: this.viewmodel.bidAdjustmentHeader,
      rows: this.viewmodel.rows,
      percentSymbol: config.get('globalization.number.percentSymbol'),
      targetType: this.options.targetType,
      targetPopupId: this.viewmodel.targetPopupId,
      showLevelToggle: this.options.showLevelToggle,
      showBidAdjustment: !(this.isMSANBoostEnabled && this.isHideBidAdjustmentForBoostEnabled),
    }));
    ko.applyBindings(this.viewmodel, this.el);
    this.toggleView.render();
    this.$('.toggle-campaign-settings-switch').append(this.toggleView.el);
    return this;
  }

  getValues() {
    return this.viewmodel.getValues();
  }

  validate() {
    return this.viewmodel.validate();
  }

  setLevel(level) {
    this.options.level = level;
    this.viewmodel.setLevel(level);
  }

  handleErrors(response) {
    return this.viewmodel.handleErrors(response);
  }

  remove(...args) {
    if (this.toggleView) {
      this.toggleView.remove();
    }
    super.remove(...args);
  }
}
